import axios from "axios";
import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { RadioGroup, Radio } from "react-radio-group";
import { Link } from "react-router-dom";
import * as Survey from "survey-core";
import * as SurveyReact from "survey-react-ui";
import { environment } from "../../environment.js";
import "survey-core/survey.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Tabs, Tab } from "react-bootstrap";

const MySwal = withReactContent(Swal);

const UserQuestionnaire = ({ history }) => {
  const [allQuestions, setAllQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [showAlert1, setShowAlert1] = useState(false);
  const [submitButton, setSubmitButton] = useState(true);
  const [feedbackId, setFeedbackId] = useState(1);
  const [activeTab, setActiveTab] = useState("1");
  const [industryId, setIndustryId] = useState(null);
  let industriestype = [];
    industriestype = [
        {
        roleType: "All",
        roleId: 0,
        },
        {
        roleType: "Corporate",
        roleId: 1,
        },
        {
        roleType: "Education",
        roleId: 2,
        },
        {
        roleType: "Healthcare",
        roleId: 3,
        },
        {
        roleType: "Hospitality",
        roleId: 4,
        },
        {
        roleType: "Manufacturing",
        roleId: 5,
        },
        {
        roleType: "Others",
        roleId: 6,
        },
    ];

  const masterTabs = [
    { name: "Awareness", id: 1 },
    { name: "Current Usage Experience", id: 2 },
    { name: "Voluntary Questions", id: 3 },
  ];

  const user_id = JSON.parse(localStorage.getItem("user"))._id;

 const fetchCustomer = async () => {
  try {
    const token = JSON.parse(localStorage.getItem("user"))?.token;
    const user_id = JSON.parse(localStorage.getItem("user"))._id;

    const res = await axios.get(`${environment.dap_url}users/${user_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = res.data;
    const industryName = data?.industry?.trim()?.toLowerCase(); // normalize
    console.log("Industry from API:", `"${industryName}"`);

    const matchedIndustry = industriestype.find(
      (item) => item.roleType.toLowerCase().trim() === industryName
    );

    if (matchedIndustry) {
      console.log(
        "Matched Industry:",
        matchedIndustry.roleType,
        "→ ID:",
        matchedIndustry.roleId
      );
      setIndustryId(matchedIndustry.roleId);
    } else {
      console.warn("No match found for industry:", industryName);
      setIndustryId(0);
    }
  } catch (error) {
    console.error("Error fetching customer:", error.response?.data || error.message);
    setIndustryId(0);
  }
};


  useEffect(() => {
    fetchCustomer();
  }, []);
  useEffect(() => {
  if (industryId !== null && industryId !== undefined) {
    console.log("Industry ID ready →", industryId);
    checkIfResponseAdded();
  }
}, [industryId]);

  const [visibleTabs, setVisibleTabs] = useState(masterTabs);

  const checkIfResponseAdded = async () => {
  let userDetails = JSON.parse(localStorage.getItem("user"));
  try {
    const res = await axios.get(
      environment.dap_url + "questionnarieApi/checIfCustmerAnsSubmitted/" + userDetails._id
    );

    const data = res?.data;

    if (data.answerCountTotal === 0) {
      // No answers yet → show all tabs
      setVisibleTabs(masterTabs);
      getAllQuestions(1);
    } else {
      // Show only tabs where questionMasterId_X == 0 (unanswered)
      const filteredTabs = masterTabs.filter(tab => data[`questionMasterId_${tab.id}`] === 0);

      if (filteredTabs.length === 0) {
        setShowAlert1(true);
        MySwal.fire({
          title: "You have already submitted the feedback!",
          icon: "info",
          confirmButtonText: "Go to dashboard",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) history.push("/dashboard");
        });
        return;
      } else {
        setVisibleTabs(filteredTabs);
        setActiveTab(filteredTabs[0].id.toString());
        getAllQuestions(filteredTabs[0].id);
      }
    }
  } catch (err) {
    console.log(err);
  }
};


  const getAllQuestions = async (masterId) => {
    setSubmitButton(true);
    setFeedbackId(masterId);
    try {
      const res = await axios.get(
        environment.dap_url + "questionnarieApi/getAllQuestionsByMasterId/" + masterId + "?industryId=" + industryId
      );
      
      res.data.forEach((element) => {
        element.responseBoolean = null;
        element.answer = "";
        element.checkboxAnswer = [];
        element.checkboxList = [];
      });

      setAllQuestions(res.data);
      setAnswers([...res.data]);
    } catch (err) {
      console.log(err);
    }
  };

  // --- Question handlers ---
  const setSelected = (e, item, op) => {
    item.answer = e;
    let objIndex = answers.findIndex((o) => o._id === item._id);
    if (objIndex > -1) answers[objIndex].answer = op;
    setAllQuestions([...answers]);
  };

  const setSelectedAnswer = (e, item) => {
    item.answer = e;
    let objIndex = answers.findIndex((o) => o._id === item._id);
    if (objIndex > -1) answers[objIndex].answer = e;
    setAllQuestions([...answers]);
  };

  const setBooleanResponse = (e, item) => {
    const boolValue = e === "true" || e === true;
    item.responseBoolean = boolValue;
    item.answer = boolValue ? "Yes" : "No";

    let objIndex = answers.findIndex((o) => o._id === item._id);
    if (objIndex > -1) {
      answers[objIndex].responseBoolean = boolValue;
      answers[objIndex].answer = boolValue ? "Yes" : "No";
    }
    setAllQuestions([...answers]);
  };

  const setSelectedCheckbox = (e, item, option) => {
    let objIndex = answers.findIndex((o) => o._id === item._id);
    if (objIndex > -1) {
      if (e.checked) {
        answers[objIndex].checkboxAnswer.push(option);
      } else {
        answers[objIndex].checkboxAnswer = answers[objIndex].checkboxAnswer.filter(
          (op) => op !== option
        );
      }
    }
    setAllQuestions([...answers]);
  };

  const handleSubmit = async () => {
    const answerObject = [];
    allQuestions.forEach((element) => {
      if (element.answer || (element.checkboxAnswer && element.checkboxAnswer.length > 0)) {
        answerObject.push({
          questionId: element._id,
          questionMasterId: feedbackId,
          userId: user_id,
          responseCheckBox: element.checkboxAnswer,
          response: element.answer,
          responseBoolean: element.responseBoolean,
          isDeleted: false,
          isActive: true,
        });
      }
    });

    if (answerObject.length > 0) {
      try {
        await axios.post(environment.dap_url + "questionnarieResponseApi/submitAnswer", answerObject);
        MySwal.fire({
          title: "Feedback Answer Submitted Successfully!",
          icon: "success",
        });
        setAllQuestions([]);
        setAnswers([]);
        checkIfResponseAdded();
      } catch (err) {
        console.log(err);
      }
    } else {
      console.log("Please fill all the required fields");
    }
  };

  // --- SurveyJS ranking ---
  const surveyJson = {
    pages: [
      {
        name: "ranking",
        elements: [
          {
            type: "ranking",
            title: "Rank the following in order of the duration?",
            isRequired: true,
            choices: [
              "Time spent in Office (Indoor)",
              "Time spent at Home(Indoor: Sleep, Meals etc. )",
              "Time spent travelling, sales etc (Outdoors)",
            ],
          },
        ],
      },
    ],
  };
  const survey = new Survey.Model(surveyJson);
  survey.onComplete.add((sender) => {
    const index = answers.findIndex((o) => o.questionTypeId === 6);
    if (index > -1) {
      answers[index].checkboxAnswer = sender.data.question1;
      setAllQuestions([...answers]);
    }
  });

  return (
    <div style={{ margin: "5%" }}>
      <div className="col-lg-3">
        <Link to={`/dashboard`} className="btn btn-light my-3">
          Back
        </Link>
      </div>

      {/* Tabs */}
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => {
          setActiveTab(k);
          getAllQuestions(Number(k));
        }}
        className="mb-3"
      >
        {visibleTabs.map((tab) => (
          <Tab eventKey={tab.id.toString()} title={tab.name} key={tab.id}>
            <div>
              {allQuestions.map((item, i) => (
                <div key={item._id} style={{ marginBottom: "20px" }}>
                  <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {i + 1}. {item.question}{" "}
                    {item.waitage && (
                      <span>
                        Weightage: <strong>{item.waitage}</strong>
                      </span>
                    )}
                  </div>

                  {/* Question types */}
                  {item.questionTypeId === 1 && (
                    <RadioGroup
                      name={item._id}
                      value={item.responseBoolean}
                      style={{ marginTop: "10px" }}
                    >
                      <Radio
                        value={true}
                        onChange={(e) => setBooleanResponse(e.target.value, item)}
                      />{" "}
                      Yes
                      <Radio
                        value={false}
                        onChange={(e) => setBooleanResponse(e.target.value, item)}
                        style={{ marginLeft: "20px" }}
                      />{" "}
                      No
                    </RadioGroup>
                  )}

                  {item.questionTypeId === 2 && item.answerOptions && (
                    <div>
                      {item.answerOptions.map((op) => (
                        <Form.Check
                          key={op.option}
                          type="radio"
                          label={op.option}
                          value={op.option}
                          checked={item.answer === op.option}
                          onChange={(e) => setSelected(e.target.value, item, op.option)}
                          style={{ marginTop: "10px" }}
                        />
                      ))}
                    </div>
                  )}

                  {item.questionTypeId === 3 && (
                    <Form.Control
                      type="text"
                      placeholder="Enter Answer"
                      onChange={(e) => setSelectedAnswer(e.target.value, item)}
                      style={{ marginTop: "10px" }}
                    />
                  )}

                  {(item.questionTypeId === 4 || item.questionTypeId === 5) &&
                    item.answerOptions &&
                    item.answerOptions.map((op) => (
                      <Form.Check
                        key={op.option}
                        type="checkbox"
                        label={op.option}
                        onChange={(e) => setSelectedCheckbox(e.target, item, op.option)}
                        style={{ marginTop: "10px" }}
                      />
                    ))}

                  {item.questionTypeId === 6 && <SurveyReact.Survey model={survey} />}

                  {item.questionTypeId === 7 && (
                    <>
                      {item.answerOptions &&
                        item.answerOptions.map((op) => (
                          <Form.Check
                            key={op.option}
                            type="radio"
                            label={op.option}
                            value={op.option}
                            checked={item.answer === op.option}
                            onChange={(e) => setSelected(e.target.value, item, op.option)}
                            style={{ marginTop: "10px" }}
                          />
                        ))}
                      <Form.Control
                        type="text"
                        placeholder="Free Writing"
                        onChange={(e) => setSelectedAnswer(e.target.value, item)}
                        style={{ marginTop: "10px" }}
                      />
                    </>
                  )}
                </div>
              ))}

              {submitButton && !showAlert1 && (
                <Button style={{ marginTop: "20px" }} onClick={handleSubmit}>
                  Submit
                </Button>
              )}
            </div>
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default UserQuestionnaire;
